// extracted by mini-css-extract-plugin
export default {"container":"announcement_container__3si5L","content":"announcement_content__Ezyxn"};